import { render, staticRenderFns } from "./ListPointBalance.vue?vue&type=template&id=7960242d"
import script from "./ListPointBalance.vue?vue&type=script&lang=js"
export * from "./ListPointBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports